/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between BMR and TDEE?`)
};

const es_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre BMR y TDEE?`)
};

const de_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen BMR und TDEE?`)
};

const nl_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen BMR en TDEE?`)
};

const fr_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre BMR et TDEE ?`)
};

const it_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra BMR e TDEE?`)
};

const pt_br2_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre BMR e TDEE?`)
};

const pt_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre TMB e TDEE?`)
};

const ja_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMRとTDEEの違いは何ですか？`)
};

const zh_bmr_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR 和 TDEE 有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq1_q", locale)
	if (locale === "en") return en_bmr_faq1_q(inputs)
	if (locale === "es") return es_bmr_faq1_q(inputs)
	if (locale === "de") return de_bmr_faq1_q(inputs)
	if (locale === "nl") return nl_bmr_faq1_q(inputs)
	if (locale === "fr") return fr_bmr_faq1_q(inputs)
	if (locale === "it") return it_bmr_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq1_q(inputs)
	if (locale === "pt") return pt_bmr_faq1_q(inputs)
	if (locale === "ja") return ja_bmr_faq1_q(inputs)
	return zh_bmr_faq1_q(inputs)
};